import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { supabase } from "../client/client";
import { useLogin } from "../context/LoginContext";
import DataGrid from "react-data-grid";
import * as XLSX from "xlsx";
import DownloadIcon from "./DownloadIcon";
import CreateIcon from "./CreateIcon";
import Layout from "./Layout";
import Loading from "./Loading";

const columns = [
  {
    key: "name",
    name: "Nombre",
    width: 280,
    renderCell: ({ row }) => <div className="font-medium">{row.name}</div>,
  },
  { key: "email",  name: "Email",  width: 280 },
  { key: "role",   name: "Rol",    width: 160 },
  { key: "charge", name: "Cargo",  width: 220 },
];

const Usuarios = () => {
  const [loading, setLoading]   = useState(true);
  const [data, setData]         = useState([]);
  const [error, setError]       = useState(null);
  const { getSessionAuth }      = useLogin();
  const navigate                = useNavigate();

  useEffect(() => {
    const init = async () => {
      try {
        const session = await getSessionAuth();
        if (!session) { navigate("/", { replace: true }); return; }
        setLoading(false);
      } catch (e) {
        setError("Error al verificar sesión.");
        setLoading(false);
      }
    };
    init();
  }, []);

  useEffect(() => {
    if (loading) return;
    const fetchData = async () => {
      try {
        const { data: usersData, error: usersError } = await supabase
          .from("users")
          .select("id, name, email, role, charge")
          .order("name", { ascending: true });

        if (usersError) { setError("Error al cargar usuarios."); return; }
        setData(usersData || []);
      } catch (e) {
        setError("Error inesperado al cargar datos.");
      }
    };
    fetchData();
  }, [loading]);

  const handleDownloadExcel = () => {
    try {
      const sheet = XLSX.utils.json_to_sheet(data.map(u => ({
        Nombre: u.name,
        Email:  u.email,
        Rol:    u.role,
        Cargo:  u.charge,
      })));
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, sheet, "Usuarios");
      XLSX.writeFile(workbook, "usuarios.xlsx");
    } catch (e) {
      console.error("Error al descargar Excel:", e.message);
    }
  };

  return (
    <Layout>
      {loading && <Loading />}
      {error && (
        <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg mb-6">
          {error}
        </div>
      )}
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-[#4691A6] font-bold text-3xl">USUARIOS</h1>
          <p className="text-gray-500 text-sm mt-1">
            {data.length} usuario{data.length !== 1 ? "s" : ""} registrado{data.length !== 1 ? "s" : ""}
          </p>
        </div>
        <div className="flex items-center gap-2">
          <Link to="/formulario-usuarios">
            <button className="bg-[#356674] hover:bg-[#4691A6] transition-colors duration-200 text-sm cursor-pointer h-9 flex gap-2 items-center px-4 py-2 text-white rounded-lg shadow-sm">
              <CreateIcon className="w-4 h-4" />
              Crear usuario
            </button>
          </Link>
          <button
            onClick={handleDownloadExcel}
            className="bg-white hover:bg-gray-50 border border-gray-200 transition-colors duration-200 text-sm cursor-pointer h-9 flex gap-2 items-center px-4 py-2 text-gray-700 rounded-lg shadow-sm"
          >
            <DownloadIcon className="w-4 h-4" />
            Exportar Excel
          </button>
        </div>
      </div>
      <div className="rounded-xl overflow-hidden border border-gray-200 shadow-sm">
        <DataGrid rows={data} columns={columns} className="rdg-light" style={{ minHeight: 400 }} />
      </div>
    </Layout>
  );
};

export default Usuarios;
